var map = {
	"./add.svg": "58n+",
	"./audio.svg": "KyOe",
	"./dataset.svg": "G2Gc",
	"./datasettle.svg": "xIY0",
	"./excel.svg": "OLl3",
	"./folder.svg": "XXSE",
	"./head.svg": "fxAQ",
	"./image.svg": "dDyW",
	"./logo.svg": "ZY77",
	"./mechanical.svg": "grZy",
	"./model.svg": "8SNX",
	"./nodata.svg": "a9Vk",
	"./progress.svg": "qPYD",
	"./settle.svg": "hkIs",
	"./task.svg": "EK3d",
	"./text.svg": "meoi",
	"./video.svg": "3JNx",
	"./view.svg": "zjNx",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 12